import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '@/auth/AuthProvider';

export function RequireAuth({ userType }: { userType?: 'INTERNAL' | 'VENDOR' }) {
  const { user, loading } = useAuth();
  const location = useLocation();
  if (loading) return <div className="route-loading">Loading your workspace…</div>;
  if (!user) return <Navigate to={userType === 'VENDOR' ? '/portal/login' : '/login'} state={{ from: location }} replace />;
  if (userType && user.userType !== userType) return <Navigate to={user.userType === 'VENDOR' ? '/portal/onboarding' : '/app'} replace />;
  return <Outlet />;
}

export function RequirePermission({ permission }: { permission: string }) {
  const { can } = useAuth();
  return can(permission) ? <Outlet /> : <div className="not-found"><span>403</span><h1>Access denied</h1><p>You do not have permission to view this area.</p></div>;
}
